module.exports = __webpack_public_path__ + "img/circle-table-1.8e18b3de.png";